export default __webpack_public_path__ + "static/media/svg-4.03b85c77.svg";